//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('choices', {
//        templateUrl: 'views/components/views/choices/choices.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'choicesService', function ($stateParams, choicesService) {
//            const vm = this;
//            let prodId = $stateParams.prod_id;

//            vm.model = {
//                setting: {},
//                itemsListChoices: []
//            };

//            async function loadSetting() {
//                vm.model.setting = (await choicesService.getSetting({ prod_id: prodId }))[0];
//            }

//            async function loadChoices() {
//                vm.model.itemsListChoices = await choicesService.listChoices({ prod_id: prodId });
//            }

//            vm.$onInit = function () {
//                loadSetting();
//                loadChoices();
//            };
//        }]
//    });
//})();
